import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      prevPathname.current = pathname;
    }
  }, [pathname]);

  return null;
}